/**
 * Loading / error / empty / populated states for the Workshop Types list
 * (BON-391). Split out of the page so each file stays inside the repo's
 * size caps.
 */
import type { WorkshopType } from '../../../api/workshop-types';

import WorkshopTypeRow from './WorkshopTypeRow';

interface WorkshopTypeListProps {
  types: WorkshopType[];
  isLoading: boolean;
  isError: boolean;
  canEdit: boolean;
  busy: boolean;
  onOpen: (type: WorkshopType) => void;
  onToggleActive: (type: WorkshopType) => void;
  onDelete: (type: WorkshopType) => void;
}

export default function WorkshopTypeList({
  types,
  isLoading,
  isError,
  canEdit,
  busy,
  onOpen,
  onToggleActive,
  onDelete,
}: WorkshopTypeListProps) {
  if (isLoading) {
    return (
      <div className="py-8 text-center text-stone-500 dark:text-stone-400 text-sm">Loading...</div>
    );
  }
  if (isError) {
    return <div className="py-8 text-center text-red-500 text-sm">Failed to load</div>;
  }
  return (
    <ul className="divide-y divide-stone-100 dark:divide-stone-700/50">
      {types.map((type) => (
        <WorkshopTypeRow
          key={type.id}
          type={type}
          canEdit={canEdit}
          busy={busy}
          onOpen={() => onOpen(type)}
          onToggleActive={() => onToggleActive(type)}
          onDelete={() => onDelete(type)}
        />
      ))}
      {types.length === 0 && (
        <li className="py-6 text-center text-stone-500 dark:text-stone-400 text-sm">
          No workshop types configured
        </li>
      )}
    </ul>
  );
}
